import React from 'react'
import PropTypes from 'prop-types'
import { DetailRow } from '../../PaymentResult/PaymentSuccess'

export default function Bank(props) {
    const primaryColor = props.primaryColor || '#334155'

    return <DetailRow label="Bank Name" value={props.data.bankName} primaryColor={primaryColor} />
}

Bank.propTypes = {
    primaryColor: PropTypes.string,
    data: PropTypes.shape({
        bankName: PropTypes.string.isRequired,
    }).isRequired,
}
